const ICONS = {
    hiss: { child: "🐍", english: "SH", chinese: "shi", linguist: "ʃ" },
    airy: { child: "🌬️", english: "F", chinese: "fa", linguist: "f" },
    pop: { child: "💥", english: "P", chinese: "pa", linguist: "p" },
    buzz: { child: "🐝", english: "Z", chinese: "zi", linguist: "z" },
    hum: { child: "🎵", english: "M", chinese: "ma", linguist: "m" },
};
export function iconFor(clusterId, theme) {
    return ICONS[clusterId]?.[theme] ?? CUSTOM_ICONS[clusterId] ?? "•";
}
const CUSTOM_ICONS = {
    tap: "▚",
    trill: "〰",
    uvular: "◠",
    bilabial: "◌",
    dental: "❘",
    lateral: "❙",
    alveolar: "❢",
    glottal: "'",
    "ejective-k": "ᵏ",
    pharyngeal: "ʕ",
    creak: "﹏",
    kick: "●",
    hihat: "×",
    snare: "◍",
    bass: "▁",
    boom: "◯",
    tss: "≈",
    clap: "◐",
    click: "•",
    "whistle-hi": "◔",
    "whistle-lo": "◕",
    "sing-oo": "○",
    "sing-ee": "◎",
    moo: "🐄",
    cluck: "🐔",
    "hiss-cat": "🐱",
    neigh: "🐴",
    laser: "↘",
    zap: "⌁",
    warp: "↗",
    static: "░",
    level: "‾",
    rising: "╱",
    dipping: "‿",
    falling: "╲",
};
export function registerCustomIcon(clusterId, icon) {
    CUSTOM_ICONS[clusterId] = icon;
}
export function customIcons() {
    return { ...CUSTOM_ICONS };
}
